import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import MultinationalTabs from '../../../components/MultinationalTabs';
import TextEditor from '../../../components/TextEditor/TextEditor';
import {
    updatePrivacyPolicy,
    allPolicices,
    policicesLoadingStatus,
    getPolicies,
} from '../../../redux/slices/settingsSlice';

export default function PrivacyPolicySettingsPage() {
    const dispatch = useDispatch();
    const policices = useSelector(allPolicices);
    const policicesStatus = useSelector(policicesLoadingStatus);

    const countriesLocalizationsData = useMemo(
        () =>
            policices?.reduce((acc, el) => {
                acc[el.lang] = { privacy_policy: el.privacy_policy };
                return acc;
            }, {}),
        [policices],
    );

    const [data, setData] = useState({
        policies: {
            sv: {
                privacy_policy: '',
            },
            no: {
                privacy_policy: '',
            },
            fi: {
                privacy_policy: '',
            },
            da: {
                privacy_policy: '',
            },
            en: {
                privacy_policy: '',
            },
            is: {
                privacy_policy: '',
            },
        },
    });

    useEffect(() => {
        setData({
            policies: {
                sv: {
                    privacy_policy:
                        countriesLocalizationsData?.sv?.privacy_policy,
                },
                no: {
                    privacy_policy:
                        countriesLocalizationsData?.no?.privacy_policy,
                },
                fi: {
                    privacy_policy:
                        countriesLocalizationsData?.fi?.privacy_policy,
                },
                da: {
                    privacy_policy:
                        countriesLocalizationsData?.da?.privacy_policy,
                },
                en: {
                    privacy_policy:
                        countriesLocalizationsData?.en?.privacy_policy,
                },
                is: {
                    privacy_policy:
                        countriesLocalizationsData?.is?.privacy_policy,
                },
            },
        });
    }, [countriesLocalizationsData]);

    const onChangeMultinational = (text, flag) => {
        const newData = {
            ...data,
            policies: { ...data.policies, [flag]: { privacy_policy: text } },
        };

        setData(newData);
    };

    const onSave = async () => {
        await dispatch(updatePrivacyPolicy(data)).unwrap();
        toast.success('Data has been saved successfully');
        dispatch(getPolicies());
    };

    return (
        <MultinationalTabs>
            <TextEditor
                onChange={onChangeMultinational}
                data={data}
                onSave={onSave}
                isDataLoading={policicesStatus === 'loading'}
                currentPage="privacy_policy"
                title="Privacy policy"
                initialData={countriesLocalizationsData}
            />
        </MultinationalTabs>
    );
}
